import { getWorkingHoursForDate } from '@/lib/helpers/WorkingHours.js'
import { formatRange } from '@/lib/helpers/HoursFormatter.js'
import moment from 'moment'
export default {
  methods: {
    getWeekTimeTable () {
      // con el día de la semana obtener el working hours que corresponda y los rangos de horas
      var workingHoursByDay = []
      // por cada día de la semana
      for (let dayMoment = moment().startOf('week').add(1, 'ms'); workingHoursByDay.length < 7; dayMoment.add(1, 'day')) {
        const chosenWorkingHour = getWorkingHoursForDate(dayMoment, this.activities.workingHours)
        let availableHours = chosenWorkingHour ? this.joinOvernight(chosenWorkingHour).filter((ah) => {
          return (ah.dow === dayMoment.day())
        }) : []
        workingHoursByDay.push({
          day: dayMoment.day(),
          hours: availableHours.sort((a, b) => {
            return a.startHour - b.startHour
          }),
        })
      }
      return workingHoursByDay
    },
    joinOvernight (workingHours) {
      const res = []
      workingHours.availableHours.forEach(aH => {
        const startingPart = this.findStartingPart(aH, workingHours)
        const endingPart = this.findEndingPart(aH, workingHours)
        if (aH.endHour === 23.98 && endingPart) {
          res.push({ ...aH, endHour: endingPart.endHour })
        } else if (!startingPart) {
          res.push(aH)
        }
      })
      return res
    },
    findStartingPart (aH, workingHours) {
      if (aH.startHour === 0) {
        const a = workingHours.availableHours
        return a.find(o => o.dow === ((aH.dow - 1 >= 0) ? aH.dow - 1 : 6) && o.endHour === 23.98)
      }
    },
    findEndingPart (aH, workingHours) {
      if (aH.endHour === 23.98) {
        const a = workingHours.availableHours
        return a.find(o => o.dow === ((aH.dow + 1 < 7) ? aH.dow + 1 : 0) && o.startHour === 0)
      }
    },
    getCurrent () {
      var now = moment()
      this.timetable.forEach((item) => {
        item.hours.forEach((hour) => {
          if (hour.dow === now.day()) {
            var start = moment().startOf('day').add(hour.startHour, 'ms')
            var end = moment().startOf('day').add(hour.endHour, 'ms')
            if (now.isAfter(start) && now.isBefore(end)) {
              item.current = true
              this.current = formatRange(hour)
            }
          }
        })
      })
    },
  },
}
